import { ShadowPortal } from '@infl-ts/ui-shadow-dom';
import { pipe } from 'fp-ts/function';
import * as O from 'fp-ts/Option';
import { useEffect, useState } from 'react';
import { UnknownBlockList } from '../../unknown-block-list';
import { jsx as _jsx } from "react/jsx-runtime";

var Portal = function Portal(_ref) {
  var children = _ref.children,
      mountNode = _ref.mountNode;

  var _useState = useState(false),
      innerHtmlEmptied = _useState[0],
      setInnerHtmlEmptied = _useState[1];

  useEffect(function () {
    if (!innerHtmlEmptied) {
      mountNode.innerHTML = '';
      setInnerHtmlEmptied(true);
    }
  }, [innerHtmlEmptied]);
  if (!innerHtmlEmptied) return null;
  return /*#__PURE__*/_jsx(ShadowPortal, {
    mountNode: mountNode,
    "data-element": "ShadowPortal",
    "data-component": "Portal",
    "data-source-file": "index.tsx",
    children: children
  });
};

var CheckMountNode = function CheckMountNode(_ref2) {
  var children = _ref2.children,
      mountId = _ref2.mountId;
  return pipe(document.getElementById(mountId), O.fromNullable, O.match(function () {
    return null;
  }, function (element) {
    return /*#__PURE__*/_jsx(Portal, {
      mountNode: element,
      children: children
    });
  }));
};

var PortalBlock = function PortalBlock(_ref3) {
  var _ref3$block = _ref3.block,
      blocks = _ref3$block.blocks,
      mountID = _ref3$block.mountID,
      href = _ref3.href,
      leafBlocks = _ref3.leafBlocks;
  return false ? /*#__PURE__*/_jsx("div", {
    id: mountID + '_ssr',
    children: /*#__PURE__*/_jsx(UnknownBlockList, {
      blocks: blocks,
      href: href,
      leafBlocks: leafBlocks
    })
  }) : /*#__PURE__*/_jsx(CheckMountNode, {
    mountId: mountID,
    children: /*#__PURE__*/_jsx(UnknownBlockList, {
      blocks: blocks,
      href: href,
      leafBlocks: leafBlocks
    })
  });
};

export default PortalBlock;